<template>
	<div v-if="device=='pc'">
		<box :customer="true" :ref="boxRef" title="选择商品" :width="800" :index="0" moduleName="goods" @hide="hide"
			@submit="submit" :store="store" selectType="checkbox" @boxdataload="boxdataload"
			:footerButton="['submit']" />
	</div>
	<div v-else>
		<phonebox :customer="true" :ref="boxRef" title="选择商品" :width="800" :index="0" moduleName="goods" @hide="hide"
			@submit="submit" :store="store" selectType="checkbox" @boxdataload="boxdataload"
			:footerButton="['submit']" />
	</div>
</template>
<style scoped>
	/* 	.footer_button {
		position: relative;
		width: 100%;
		flex-direction: row;
		align-items: flex-end;
		justify-content: flex-end;
		margin-top: 10px;
	} */
</style>
<script>
	import box from '@_system/components/formcomponents/common/box/index.vue'
	export default {
		props: {
			store: {
				type: Object,
				default: () => {
					return {}
				}
			},
			data: {
				default: () => {
					return {}
				}
			},
		},
		data() {
			return {
				radio:null,
				index: 0,
				foreingKey: null,
				boxRef: 'box_' + Math.random(),
				box: null,
				boxConfig: {
					columns: [{
						field: 'supplierid',
						title: '供应商',
						formatter: 'supplier',
						render: '$supplier',
						props: {
							emptyoption: false,
							multiple: true,
						}
					}, {
						field: 'goodscode',
						title: '商品编码',
						render: '$input'
					}, {
						field: 'goodsname',
						title: '商品名称',
						render: '$input'
					}, {
						field: 'goodsmodel',
						title: '商品规格',
						render: '$input'
					}, {
						field: 'recommendlevel',
						title: '推荐等级',
						props: {
							emptyoption: false,
							multiple: true,
							selectoptions: [{
								value: 'S',
								label: 'S'
							}, {
								value: 'A',
								label: 'A'
							}, {
								value: 'B',
								label: 'B'
							}, {
								value: 'C',
								label: 'C'
							}, {
								value: 'D',
								label: 'D'
							}, {
								value: '新品',
								label: '新品'
							}],
						},
						render: '$select'
					}, {
						field: 'taxprice',
						title: '采购单价'
					}],
					pagerConfig: {
						currentPage: 1,
						pageSize: 200,
						enabled: true,
						pageSizes: [10, 20, 50, 200],
						force: false
					},
				},

			}
		},
		created() {

		},
		mounted() {
			let box = this.$refs[this.boxRef]
			box.buttonShow = false
			this.box = box
			this.box.list = this.list
			this.box.show = this.show
			// this.box.checkMethod = ({
			// 	row
			// }) => {
			// 	return !row.reconciliationbilldetailid
			// }

		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},

		methods: {
			show() {
				// if (this.box.getTable()) {
				// 	this.box.getTable().commitProxy('query')
				// }
			},
			initList() {
				if (!this.box.gridOptions) {
					this.box.initBox(this.boxConfig)
				}
			},
			list(page, form, other) {
				// console.log(page, form, other)
				return new Promise((resolve) => {
					this.$api.stockwarning.getsuppliergoods({
						supplierwlnid: this.data.supplierID,
						mode: 'box',
						index: this.index,
						...page,
						...form,
						...this.foreingKey,
						...other
					}).then((res) => {
						resolve(res)
					}, () => {
						resolve({
							list: []
						})
					})
				})
			},
			boxdataload(e) {
				this.$emit('boxdataload', e)
			},
			submit(e) {
				this.$emit('submit', e)
			},
			hide() {
				this.$emit('back')
			}
		},
		components: {
			box
		}
	}
</script>